<div class="wrapper">

    <h1 role="heading" class="screen-reader-only" aria-label="My Supervisors">My Supervisors</h1>
    <span class="mb-3 h4" style="display: inline-block;">My Supervisors</span>

    <mat-expansion-panel (opened)="infoPanelOpenState = true" (closed)="infoPanelOpenState = false">
        <mat-expansion-panel-header aria-label="Assigned supervisors may...">
            <mat-panel-title class="expansion-text">
                <ng-container *ngIf="!infoPanelOpenState">
                    <i class="fa fa-info-circle fa-fw mr-3 mt-1"></i>
                    Assigned supervisors may...
                </ng-container>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="expansion-text">
            <p>
                <i class="fa fa-info-circle fa-fw mr-1"></i>Assigned supervisors may download a reporting export for monitoring and informational purposes. 
                Supervisors are asked not to publish or share information from the exports without consent from 
                the employee as the narratives may not be written for public consumption. To see what supervisors 
                can see, select a date range or all time below, then click on the export button. 
            </p>
            <p>
                If you have questions or see any missing information, please contact Academic Human Resources 
                (Anna Lee at <a href="mailto:anlee@ucanr.edu"><i class="fa fa-envelope fa-fw mr-1"></i>anlee@ucanr.edu</a>).
            </p>
        </div>
    </mat-expansion-panel> 

    <div class="col-lg-12 p-0 pt-3">
        <div class="col-lg-7 float-left">
            <div *ngIf="loading">
                <p>Loading...</p>
            </div>
            <div *ngIf="!loading && supervisorList.length === 0">
                <div class="alert alert-warning">
                    <i class="fa fa-warning"></i> No supervisors found.
                </div>
            </div>
            <!-- supervisor table -->
            <table class="table table-bordered table-flush" *ngIf="!loading && supervisorList.length > 0">
                <thead>
                    <tr>
                        <th>Supervisor Name</th>
                        <th class="text-center">Role</th>
                    </tr>
                    <tr *ngFor="let supervisor of supervisorList; index as i">
                        <td>{{supervisor.details.name}}</td>
                        <td class="text-center">{{getSupervisorTitle(i)}} <small class="text-muted">({{getFormattedRole(supervisor.reviewParticipation)}})</small></td>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="col-lg-5 float-right p-0" *ngIf="!loading && supervisorList.length > 0">
            <span class="mt-3 pt-1 h6" style="text-align: center; display: block;">Supervisor Export</span>
            <button class="btn btn-primary btn-block btn-block-wrap mt-1" (click)="openExportDataDialog()">
                <i class="fa fa-fw fa-cloud-download"></i>
                Export Data
            </button>
        </div>
    </div>
</div>